import React from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleBarChart } from '@carbon/charts-react';
import { useMoney } from 'src/hooks/useMoney';
import { useTransactionCategories } from 'src/hooks/useTransactionCategories';
import { useChartTheme } from './useChartTheme';

interface SalesByMenuProps {
  title: string;
  transactionsCategories: any[];
}

const TransactionsCategories = React.memo((props: SalesByMenuProps) => {
  const { t } = useTranslation('dashboard');
  const chartTheme = useChartTheme();
  const { format, formatCompact } = useMoney();
  const { isLoading, data: transactionCategories } = useTransactionCategories();
  const transformedTransactionCategories =
    transactionCategories?.data?.reduce((previousObject, currentObject) => {
      return Object.assign(previousObject, {
        [currentObject.id]: currentObject.name,
      });
    }, {}) || {};

  return (
    <div className="dashboard__stat_widget">
      <SimpleBarChart
        data={
          isLoading || Object.keys(transformedTransactionCategories).length === 0
            ? []
            : props.transactionsCategories?.map((item) => {
                return {
                  group: transformedTransactionCategories[item.transactionCategoryId],
                  value: item.transactionTotal,
                };
              })
        }
        options={{
          title: props.title,
          axes: {
            left: {
              title: t('total'),
              mapsTo: 'value',
              ticks: {
                formatter: (value) => formatCompact(value),
              },
            },
            bottom: {
              title: t('category'),
              mapsTo: 'group',
              scaleType: 'labels' as any,
            },
          },
          tooltip: { valueFormatter: (value) => format(value) },
          height: '400px',
          theme: chartTheme,
        }}
      />
    </div>
  );
});

export default TransactionsCategories;
